import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TApiaLoadForm, TApiaLoad } from '../types';

let lastId = 0;
interface IApiaApiState {
  currentForm: {
    definition?: TApiaLoad<TApiaLoadForm> | undefined;
    id: number;
  };
  values: Record<string, string>;
}

function getInitialState() {
  return {
    currentForm: { definition: undefined, id: -1 },
    values: {},
  } as IApiaApiState;
}

const apiaApiSlice = createSlice({
  name: 'apiaApiSlice',
  initialState: getInitialState(),
  reducers: {
    resetForm(state) {
      const newState = getInitialState();
      Object.entries(newState).forEach(([key, value]) => {
        state[key as keyof typeof state] = value;
      });
    },
    setCurrentForm(
      state,
      {
        payload: { currentForm },
      }: PayloadAction<{
        currentForm: IApiaApiState['currentForm']['definition'] | undefined;
      }>,
    ) {
      state.currentForm = { definition: currentForm, id: lastId++ };
    },
    setValues(state, { payload }: PayloadAction<Record<string, string>>) {
      state.values = { ...state.values, ...payload };
    },
    setValue(
      state,
      {
        payload: { name, value },
      }: PayloadAction<{ name: string; value: string }>,
    ) {
      state.values[name] = value;
    },
  },
});

export const apiaApiActions = apiaApiSlice.actions;
export default apiaApiSlice.reducer;
